<template>
  <div class="milestones_2_container">
    <div class="milestones_2_top" :style="{borderRight: global_months.length > 0 ? 'none' : '#EEEEEE 1px solid'}">
      <div class="milestones_2_top_1">
        <div>Milestones</div>
      </div>
      <div class="milestones_2_top_2" v-for="(month, index) in global_months">
        <div>{{ month }}</div>
      </div>
    </div>
    <div class="milestones_2_content">
      <div v-for="(item, index) in all_stages_by_month" class="milestones_2_content_item"
           :style="{borderBottom: all_stages_by_month.length > 0 && index==all_stages_by_month.length - 1? 'none' : '#EEEEEE solid 1px'}">
        <div class="milestones_2_top_1">
          <div style="width: 95%; font-size: 0.8rem; text-align: left">{{ item.stage_name }}</div>
        </div>
        <div class="milestones_2_top_2 content_item" v-for="(month_cnt, index) in item.months">
          {{ month_cnt }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "milestones_2",
  props: ['global_months', 'all_stages_by_month'],
}
</script>

<style scoped>
.milestones_2_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.milestones_2_top {
  display: flex;
  width: calc(100% - 1px);
  border: #EEEEEE 1px solid;
  height: 15%;
  font-size: 1rem;
  color: white;
}

.milestones_2_top_1 {
  width: calc(32% - 1px);
  border-right: #EEEEEE 1px solid;
  height: 100%;
  padding-left: 2%;
  display: flex;
  align-items: center;
  background-color: #0C283AC5;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-bottom: 1px solid #EEEEEE;
}

.milestones_2_top_2 {
  width: calc(11% - 1px);
  border-right: #EEEEEE 1px solid;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  background-color: #0C283AC5;
}

.milestones_2_content {
  width: 100%;
  height: 82%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.milestones_2_content_item {
  width: calc(100% - 1px);
  min-height: 21%;
  border-bottom: #EEEEEE 1px solid;
  border-left: #EEEEEE 1px solid;
  font-size: 1.1rem;
  color: white;
  display: flex;
}

.content_item {
  background-color: #1E3344C5;
  border-bottom: 1px solid #EEEEEE;
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication/milestones_2.vue